export default __webpack_public_path__ + "static/media/8.394d2d58.jpg";